import React from 'react';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';

export const DirectResourceBookingEmptyAlert: React.FC = () => {
  const { t } = useTranslation('manage');

  return (
    <Alert
      type="warning"
      showIcon
      title={t('appointmentComponents.create.resource.allServiceLinkedTitle')}
      description={t('appointmentComponents.create.resource.allServiceLinkedDescription')}
    />
  );
};
